import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";

export const Route = createFileRoute("/admin/orders/$id")({
  head: () => pageHead("Admin \u2014 Orders \u2014 Id \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminOrderDetail,
});
